import type {IAugmentedJQuery, IOnChanges, IOnChangesObject} from 'angular';

export class KpLazyLoadImgComponentController implements KpLazyLoadImgBindings, IOnChanges {
    public url: string;
    public load: boolean;
    public loaded = false;

    /*@ngInject*/
    constructor(private $element: IAugmentedJQuery) {
    }

    public $onChanges(onChangesObj: IOnChangesObject): void {
        if (onChangesObj.load) {
            this.loaded = this.loaded || this.load;
            this.$element.toggleClass('loaded', this.loaded).toggleClass('not-loaded', !this.loaded);
        }
    }
}

/**
 * @ngdoc component
 * @name kpLazyLoadImg
 * @module portaro.components
 *
 * @param {string} url URL of image.
 * @param {boolean} load If `true`, load image.
 *
 * @description
 * Component for lazy loading images. If `load` attribute is not `true`, image is not loaded and `jp-loading` is shown.
 * If `load` is `true` and is changed to `false`, loaded image is still visible.
 */
// eslint-disable-next-line max-classes-per-file
export default class KpLazyLoadImgComponent {
    public static componentName = 'kpLazyLoadImg';

    public bindings = {
        url: '<',
        load: '<'
    };

    public templateUrl = require('./kp-lazy-load-img.tpl.pug');

    public controller = KpLazyLoadImgComponentController;
}

export interface KpLazyLoadImgBindings {
    url: string;
    load: boolean;
}
